import React from 'react';
import { PhoneIcon, MailIcon } from 'lucide-react';
export function Logo() {
  return <div className="flex flex-col sm:flex-row items-center sm:justify-between w-full gap-3 sm:gap-4" data-id="element-1155">
      <div className="flex items-center flex-shrink-0" data-id="element-1156">
        <img src="https://cdn.magicpatterns.com/uploads/jAaJbUwB1t1dUCrFYJwyZT/Unknown_9.jpg" alt="TrueScore & USA TKD" className="h-16 sm:h-20 w-auto" data-id="element-1157" />
      </div>
      <div className="flex flex-col sm:flex-row items-center sm:items-end gap-2 sm:gap-5 text-slate-700" data-id="element-1158">
        <div className="flex flex-col items-center sm:items-end" data-id="element-1159">
          <div className="flex items-center mb-0.5" data-id="element-1160">
            <PhoneIcon size={14} className="mr-1.5 text-red-600 flex-shrink-0" data-id="element-1161" />
            <span className="text-xs sm:text-sm font-medium" data-id="element-1162">
              (517) 294-0315
            </span>
          </div>
          <div className="flex items-center" data-id="element-1163">
            <MailIcon size={14} className="mr-1.5 text-red-600 flex-shrink-0" data-id="element-1164" />
            <span className="text-xs sm:text-sm font-medium" data-id="element-1165">
              shane@tkdscore.com
            </span>
          </div>
        </div>
        <div className="hidden sm:block border-l border-slate-300 self-stretch" data-id="element-1166"></div>
        <div className="border-t sm:border-t-0 border-slate-200 pt-2 sm:pt-0 flex flex-col items-center sm:items-end" data-id="element-1167">
          <span className="text-xs sm:text-sm font-semibold text-slate-800 mb-0.5" data-id="element-1168">
            TrueScore/CnoWire Inc
          </span>
          <div className="flex items-center" data-id="element-1169">
            <PhoneIcon size={14} className="mr-1.5 text-red-600 flex-shrink-0" data-id="element-1170" />
            <span className="text-xs sm:text-sm font-medium" data-id="element-1171">
              (510) 556-5516 ext 102
            </span>
          </div>
        </div>
      </div>
    </div>;
}